<template>
    <div class="message" :class="{'user': type !== 'robot'}">
      <div class="bubble">
        <div class="avatar" v-if="type === 'robot'">
          <avatar-robot></avatar-robot>
        </div>
        <div class="content">{{ body }}</div>
      </div>
    </div>
</template>

<script>
import AvatarRobot from '../components/AvatarRobot'
export default {
    components: {
        AvatarRobot
    },
    props: {
        type: {
            type: String,
            default: 'robot'
        },
        body: {
            type: String,
            default: null
        }
    }
}
</script>